import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {TeamModel} from '../../../../libs/shared/core/src/models/api/teamModel';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {TagModel} from '../../../models/api/tagModel';
import {maybeRenderAccessory} from './settingsSearchAccessoryHelpers';
import {
  SettingsSearchDropdownContent,
  SettingsSearchDropdownItem,
  SettingsSearchDropdownItemLeftIcon,
  SettingsSearchDropdownSubtitle,
  SettingsSearchDropdownTitle,
} from './settingsSearchCommon';
import {SettingsSearchDropdownItemBaseProps} from './settingsSearchCommonTypes';
import {SettingsSearchTagIcon} from './settingsSearchTagIcon';

/*
 * Props.
 */

interface SettingsSearchDropdownTagItemProps extends SettingsSearchDropdownItemBaseProps {
  tag: TagModel;
  team?: TeamModel;
  inboxesDescription: string;
}

/*
 * Component.
 */

const StyledArchivedBadge = styled.div`
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.veryTiny};
  color: ${(p) => p.theme.greys.shade80};
  text-transform: uppercase;
  padding: 3px 5px 3px;
  background-color: ${(p) => p.theme.alphas.gray20};
  border-radius: 100px;
  display: inline-block;
  margin-right: 6px;
  line-height: 1;
  vertical-align: middle;
  margin-top: -2px;
`;

export const SettingsSearchDropdownTagItem: FC<SettingsSearchDropdownTagItemProps> = (props) => {
  const {tag, inboxesDescription} = props;

  const label = inboxesDescription;

  return (
    <SettingsSearchDropdownItem checkmarkLabel={label} onSelect={props.onSelect}>
      <SettingsSearchDropdownItemLeftIcon>
        <SettingsSearchTagIcon tag={tag} />
      </SettingsSearchDropdownItemLeftIcon>
      <SettingsSearchDropdownContent>
        <SettingsSearchDropdownTitle>
          {tag.archivedAt && (
            <StyledArchivedBadge>
              <Trans id="tag-archived">Archived</Trans>
            </StyledArchivedBadge>
          )}
          {tag.name}
          {maybeRenderAccessory(props.tag, props.team)}
        </SettingsSearchDropdownTitle>
        <SettingsSearchDropdownSubtitle>{label}</SettingsSearchDropdownSubtitle>
      </SettingsSearchDropdownContent>
    </SettingsSearchDropdownItem>
  );
};
